var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAhrColoredIconSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4514_378)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3332 7.8418C25.5375 7.47676 24.6527 7.27344 23.7199 7.27344H23.3883H6.28008C4.5457 7.27344 2.97598 7.97656 1.83926 9.11269C0.703125 10.2494 0 11.8197 0 13.5535C0 15.2879 0.703125 16.8576 1.83926 17.9943C2.97598 19.1311 4.5457 19.8336 6.28008 19.8336C9.74883 19.8336 12.5602 17.0223 12.5602 13.5535V13.4498H17.4398V13.5535C17.4398 15.2879 18.143 16.8576 19.2791 17.9943C20.3426 19.0584 21.7869 19.7422 23.39 19.8248C23.4996 19.8307 23.6092 19.8336 23.7199 19.8336C24.9246 19.8336 26.0496 19.4949 27.0053 18.9066H27.0059C27.426 18.6482 27.8139 18.3412 28.1607 17.9943C29.2969 16.8576 30 15.2879 30 13.5535C30 11.0176 28.4971 8.8332 26.3332 7.8418Z",
    fill: "#00AF87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7239 21.5949C23.6131 21.5949 23.5023 21.5925 23.3922 21.5884V23.307C23.3922 24.1472 23.0517 24.9078 22.501 25.4591C21.9502 26.0093 21.1896 26.3498 20.3494 26.3498C18.6695 26.3498 17.3066 24.9875 17.3066 23.307V22.5508H18.2168V20.793H12.7578V22.5508H13.6897V23.3287C13.6897 25.1673 14.435 26.8326 15.6403 28.0379C16.845 29.2431 18.5102 29.989 20.3495 29.989C24.0274 29.989 27.0098 27.0066 27.0098 23.3287V20.8976C25.9897 21.3546 24.8752 21.5949 23.7239 21.5949Z",
    fill: "#00AF87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4688 0.0117188V1.76953H23.3897V5.5166H23.7213C24.8727 5.5166 25.9871 5.75684 27.0072 6.21387V1.76953H27.9278V0.0117188H22.4688Z",
    fill: "#00AF87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4514_378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhrColoredIconSeven);
export default __webpack_public_path__ + "static/media/ahr-colored-icon-seven.6070a62490e0a42005fd3a3b09670983.svg";
export { ForwardRef as ReactComponent };